import {observer} from 'mobx-react';
import Modal from 'shared/components/modals/Modal';
import ModalButtons from 'shared/components/modals/ModalButtons';
import {DragAndDrop} from 'shared/components/dnd';
import {Select2, Spinner} from 'shared/components';

const ReorderFoldersModal = observer(({modalOpen, uiState}) => {
  const {reorderingFolders, reorderParentFolder, folders, fetchingReorderingFolders} = uiState;

  return (
    <Modal
      title='company_settings.document_folders.Reorder Document Folders'
      isOpen={modalOpen}
      onHide={() => uiState.closeReorderFoldersModal()}
      size='md'
    >
      <div className='mb2'>
        <Select2
          label='company_settings.document_folders.Parent Folder'
          value={reorderParentFolder?.id}
          onChange={e => uiState.selectReorderParentFolder(
            folders.find(f => f.id === e.target.value) || null
          )}
          allowClear
        >
          {folders.filter(f => f.hasSubfolders).map(folder => (
            <option value={folder.id} key={folder.id}>{folder.name}</option>
          ))}
        </Select2>
      </div>
      {fetchingReorderingFolders
        ? <Spinner/>
        : <DragAndDrop models={reorderingFolders} component={({model}) => <div>{model.name}</div>}/>
      }
      <ModalButtons
        saveEnabled={!fetchingReorderingFolders}
        onSave={() => uiState.saveFolderOrders()}
        onCancel={() => uiState.closeReorderFoldersModal()}
      />
    </Modal>
  );
});

export default ReorderFoldersModal;
